import { Roles } from 'src/shared/enums';
import { RoleGuard } from 'src/portal-app/auth/guards/role.guard';
import { AuthGuard } from '../shared/auth/guards/auth.guard';

export const railroadsPaths = {
	default: '',
	root: 'railroads',
	list: 'list',
	detail: ':id',
};

export const railroadsFragments = {
	default: [railroadsPaths.default],
	root: [railroadsPaths.default, railroadsPaths.root],
	list: [railroadsPaths.default, railroadsPaths.root, railroadsPaths.list],
	detail: (id: number) => [railroadsPaths.default, railroadsPaths.root, id],
};

export const railroadsDefaultAuthRoles = [
	Roles.Admin,
	Roles.FieldDirector,
	Roles.FieldManager,
	Roles.FieldSupport,
	Roles.HR,
];

export const railroadsDefaultAuth = {
	canActivate: [AuthGuard, RoleGuard],
	data: {
		roles: railroadsDefaultAuthRoles,
	},
};
